import MobileApp from './MobileApp';

export default MobileApp;
